<template>
    <div>
        <div class="emp_organogram_block">
            <ContentHeaderSection :title="'Decision List'" :icon="'fa fa-bar'" />
            <div class="" v-if="(deskassign.length > 0)">
                <draggable handle=".section_drag" tag="div" :list="deskassign" :group="{ name: 'g1' }">
                    <template v-for="(designation, n_index) in deskassign" :key="designation.id">
                        <app-accordion class="section_drag p-2 rounded-lg shadow-lg bg-[#ffffff] w-full mt-2 ">
                            <template v-slot:drag>
                                <div class="flex flex-col input_block items-center w-[30px]">
                                    <i class="section_checkbox rounded-full">
                                        {{ n_index + 1 }} .
                                    </i>
                                    <i class="fa fa-up-down-left-right rounded-full section_drag_cross"></i>
                                </div>
                            </template>
                            <template v-slot:title>
                                <span class="font-semibold text-sm">
                                    {{ designation.name }}
                                </span>
                            </template>
                            <template v-slot:clone>
                                <i class="fa-solid fa-copy cursor-pointer text-[#515151]" @click="onClone(n_index)"></i>
                                <i class="fa-solid fa-trash cursor-pointer text-[#C70833]"
                                    @click="onRemove(n_index)"></i>
                            </template>

                            <template v-slot:content>
                                <status-toogle-button v-model="designation.can_print" label="Print"
                                    class=""></status-toogle-button>
                                <status-toogle-button v-model="designation.draft_print" label="Draft Print"
                                    class=""></status-toogle-button>
                                <status-toogle-button v-model="designation.summary_view" label="Summary"
                                    class=""></status-toogle-button>
                                <p class="text-gray-700 text-base mb-1 mt-2">
                                    <Multiselect v-model="designation.decision" mode="tags"
                                        placeholder="Select Decision Step" :options="decison" :search="true"
                                        @select="onChangeAddData(n_index)"
                                        @deselect="onChangeRemoveData($event, n_index)" />
                                </p>
                                <ul
                                    class="w-full rounded-lg mt-2 mb-3 text-blue-800 divide-y divide-gray-200 bg-white shadow-sm">
                                    <template v-for="(deci, s_index) in designation.alldecision" :key="deci.id">
                                        <input v-if="deci.layer === null" type="text" v-model="deci.layer"
                                            @input="deci.layer = geo_infos.value.office_layer_id" />

                                        <li class="mb-3 p-4 rounded-lg hover:bg-blue-50 transition-all duration-150">
                                            <div
                                                class="active designation_block flex flex-col gap-3 items-start justify-between">
                                                <div
                                                    class="flex gap-3 items-center w-full border-b border-gray-100 pb-2 mb-2">
                                                    <div class="input_block">
                                                        <i v-if="getDecisionName(decison, deci.id)"
                                                            class="fa fa-check check"></i>
                                                        <i v-else class="fa fa-question text-gray-400"></i>
                                                    </div>
                                                    <div class="designation font-semibold text-base text-gray-800">
                                                        {{ getDecisionName(decison, deci.id) }}
                                                    </div>
                                                </div>
                                                <div class="w-full">
                                                    <div class="flex flex-wrap gap-4 items-center w-full mt-2 mb-2"
                                                        v-if="designation.decision.includes(deci.id) && (deci.id == 2 || deci.id == 1 || deci.id == 24)">
                                                        <template v-for="type in proceed_type" :key="type.id">
                                                            <div class="flex items-center">
                                                                <input type="radio"
                                                                    :id="'proceed_type_' + n_index + '_' + s_index + '_' + type.id"
                                                                    :name="'proceed_type_' + n_index + '_' + s_index"
                                                                    :value="type.id" v-model="deci.proceed_type"
                                                                    class="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-full bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 align-top bg-no-repeat bg-center bg-contain cursor-pointer">
                                                                <label
                                                                    class="form-check-label inline-block text-gray-700 ml-2 text-sm"
                                                                    :for="'proceed_type_' + n_index + '_' + s_index + '_' + type.id">{{
                                                                        type.name }}</label>
                                                            </div>
                                                        </template>
                                                    </div>
                                                    <div class="flex flex-col gap-2 w-full mt-2 mb-2"
                                                        v-if="designation.decision.includes(deci.id) && (deci.id == 2 || deci.id == 1 || deci.id == 24) && (deci.proceed_type == 1 || deci.proceed_type == null)">
                                                        <label class="form-label font-medium">Desk</label>
                                                        <Multiselect v-model="deci.designation" mode="tags"
                                                            placeholder="Select Options" :options="designationOptions"
                                                            :search="true" />
                                                    </div>
                                                    <div class="flex flex-col gap-2 w-full mt-2 mb-2"
                                                        v-if="deci.proceed_type == 2">
                                                        <div class="mt-2"
                                                            v-if="designation.decision.includes(deci.id) && (deci.id == 1 || deci.id == 2 || deci.id == 24)">
                                                            <label class="form-label font-medium">Office</label>
                                                            <select v-model="deci.org_id" class="form-select"
                                                                @change="loadOffice($event, deci.org_id, n_index, s_index)">
                                                                <option value=null>Select Office</option>
                                                                <template v-for="(layer, s_index) in layerData"
                                                                    :key="layer.id">
                                                                    <option :value="layer.id" :data="layer.layer">{{
                                                                        layer.name }}</option>
                                                                </template>
                                                            </select>
                                                        </div>
                                                        <div class="w-full mt-2"
                                                            v-if="designation.decision.includes(deci.id) && (deci.id == 1 || deci.id == 2 || deci.id == 24)">
                                                            <label class="form-label font-medium">Desk</label>
                                                            <Multiselect v-model="deci.designation" mode="tags"
                                                                placeholder="Select Options" :options="deci.officeData"
                                                                :search="true" />
                                                        </div>
                                                    </div>
                                                    <div class="flex flex-col gap-2 w-full mt-2 mb-2"
                                                        v-if="deci.proceed_type == 3">
                                                        <div class="mt-2"
                                                            v-if="designation.decision.includes(deci.id) && (deci.id == 1 || deci.id == 2 || deci.id == 24)">
                                                            <label class="form-label font-medium">Office</label>
                                                            <Multiselect v-model="deci.org_id" :options="layers"
                                                                placeholder="Select Office" :search="true"
                                                                :close-on-select="false" :multiple="true"
                                                                @change="(values) => handleChange(values, n_index, s_index)"
                                                                mode="tags">
                                                                <template #option="{ option }">
                                                                    <span>{{ option.label }}</span>
                                                                    <span class="text-gray-500 text-xs ml-2">({{
                                                                        option.layer }})</span>
                                                                </template>
                                                            </Multiselect>
                                                        </div>
                                                        <div class="w-full mt-2"
                                                            v-if="designation.decision.includes(deci.id) && (deci.id == 1 || deci.id == 2 || deci.id == 24)">
                                                            <label class="form-label font-medium">Desk</label>
                                                            <Multiselect v-model="deci.designation" mode="tags"
                                                                placeholder="Select Options" :options="deci.officeData"
                                                                :search="true" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- ...existing code for status-toogle-button, prerequisites, and other sections... -->
                                            <status-toogle-button v-model="deci.is_open" label="Open "
                                                class="px-1"></status-toogle-button>
                                            <status-toogle-button v-model="deci.open_desk" label="Open Desk"
                                                class="px-1"></status-toogle-button>
                                            <status-toogle-button v-model="deci.has_evaluation" label="Evaluation Form"
                                                class="px-1"></status-toogle-button>

                                            <div class="flex items-center gap-2 px-1 designation_block active justify"
                                                v-if="s_index > 0">
                                                <div>
                                                    <status-toogle-button v-model="deci.has_prerequisite"
                                                        label="Prerequisite" class=""></status-toogle-button>
                                                </div>
                                                <div class=" ml-auto w-[10rem]" v-if="deci.has_prerequisite > 0">
                                                    <label class="form-label">Decision</label>
                                                    <select v-model="deci.prerequisite" class="form-select">
                                                        <option value=null>Please Select Decision</option>
                                                        <template v-for="(decisonInfo, s_index) in decisonInfos"
                                                            :key="decisonInfo.id">
                                                            <option :value="decisonInfo.id">{{
                                                                decisonInfo.decision_title }}
                                                            </option>
                                                        </template>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="flex mt-5 px-1">
                                                <div class="designation">Data Input</div>
                                                <div class="ml-auto">
                                                    <ul class="grid grid-cols-2 gap-x-2  mx-auto ">
                                                        <li class="relative">
                                                            <input class="sr-only peer" type="radio" value="yes"
                                                                v-model="deci.approve_status"
                                                                :id="designation.serial + '_answer_yes_f_' + deci.id">
                                                            <label
                                                                class="flex p-1 px-4 bg-white border border-gray-300 rounded-lg cursor-pointer focus:outline-none hover:bg-gray-50 peer-checked:ring-green-500 peer-checked:ring-2 peer-checked:border-transparent"
                                                                :for="designation.serial + '_answer_yes_f_' + deci.id">Yes</label>
                                                            <div
                                                                class="absolute hidden w-2 h-2 peer-checked:block top-[4px] right-2">
                                                                <i class="fa-solid fa-check"></i>
                                                            </div>
                                                        </li>
                                                        <li class="relative">
                                                            <input class="sr-only peer" type="radio" value="no"
                                                                v-model="deci.approve_status"
                                                                :id="designation.serial + 'answer_no_f_' + deci.id">
                                                            <label
                                                                class="flex p-1 px-4 bg-white border border-gray-300 rounded-lg cursor-pointer focus:outline-none hover:bg-gray-50 peer-checked:ring-red-500 peer-checked:ring-2 peer-checked:border-transparent"
                                                                :for="designation.serial + 'answer_no_f_' + deci.id">No</label>
                                                            <div
                                                                class="absolute hidden w-2 h-2 peer-checked:block top-[4px] right-2">
                                                                <i class="fa-solid fa-xmark"></i>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="flex mt-3 px-1" v-if="deci.approve_status == 'yes'">
                                                <div class="designation">Data Input Fields</div>
                                                <div class="flex mx-2  ">
                                                    <div class="grid grid-cols-2">
                                                        <div class="flex flex-row items-center gap-1 form-check form-check-inline px-2 mb-2 h-8"
                                                            v-for="(approvedata, s_index) in approvedatas"
                                                            :key="approvedata.id">
                                                            <input type="checkbox" v-model="deci.approve_data"
                                                                :id="approvedata.id"
                                                                class="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 align-top bg-no-repeat bg-center bg-contain float-left cursor-pointer"
                                                                :value='approvedata.id'
                                                                @change="approve_data_update(deci)">&nbsp;
                                                            <label :for="approvedata.id"
                                                                class="form-check-label inline-block text-gray-600">{{
                                                                    approvedata.value
                                                                }}</label>
                                                            <status-toogle-button
                                                                v-model="deci.optional[approvedata.id]" label=""
                                                                class="px-1 w-[30px]"></status-toogle-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex mt-3 px-1" v-if="deci.approve_status == 'yes'">
                                                <div class="designation">Data</div>
                                                <div class="ml-auto">
                                                    <ul class="grid grid-cols-2 gap-x-2  mx-auto ">
                                                        <li class="relative">
                                                            <input class="sr-only peer" type="radio" value="view"
                                                                v-model="deci.mode" name="field_mode"
                                                                :id="designation.serial + 'field_mode_view_f_' + deci.id">
                                                            <label
                                                                class="flex p-1 px-4 bg-white border border-gray-300 rounded-lg cursor-pointer focus:outline-none hover:bg-gray-50 peer-checked:ring-green-500 peer-checked:ring-2 peer-checked:border-transparent"
                                                                :for="designation.serial + 'field_mode_view_f_' + deci.id">View</label>
                                                            <div
                                                                class="absolute hidden w-2 h-2 peer-checked:block top-[4px] right-2">
                                                                <i class="fa-regular fa-eye"></i>
                                                            </div>
                                                        </li>
                                                        <li class="relative">
                                                            <input class="sr-only peer" type="radio" value="write"
                                                                v-model="deci.mode"
                                                                :id="designation.serial + 'field_mode_write_f_' + deci.id">

                                                            <label
                                                                class="flex p-1 px-4 bg-white border border-gray-300 rounded-lg cursor-pointer focus:outline-none hover:bg-gray-50 peer-checked:ring-indigo-500 peer-checked:ring-2 peer-checked:border-transparent"
                                                                :for="designation.serial + 'field_mode_write_f_' + deci.id">Write</label>
                                                            <div
                                                                class="absolute hidden w-2 h-2 peer-checked:block top-[4px] right-[6px]">
                                                                <i class="fa-regular fa-pen-to-square"></i>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="flex items-center gap-2 px-1 designation_block active justify mt-2"
                                                v-if="designation.decision.includes(deci.id) && ((deci.id == 6) || (deci.id == 9) || (deci.id == 18) || (deci.id == 19))">
                                                <div>
                                                    <status-toogle-button v-model="deci.has_proceed" label="Proceed "
                                                        class=""></status-toogle-button>
                                                </div>

                                                <div class=" ml-auto w-[10rem]">
                                                    <template v-if="deci.has_proceed > 0">
                                                        <label class="form-label">Desk</label>

                                                        {{ deci.has_proceed }}
                                                        <select v-model="deci.proceed" class="form-select">
                                                            <option value=null>None</option>
                                                            <template v-if="deci.has_proceed > 0">
                                                                <template
                                                                    v-for="(designation_op, s_index) in designation_data"
                                                                    :key="designation_op.id">
                                                                    <option
                                                                        v-if="designation.serial != designation_op.serial"
                                                                        :value="designation_op.id">{{
                                                                            designation_op.name }}
                                                                    </option>
                                                                </template>
                                                            </template>
                                                        </select>
                                                    </template>
                                                </div>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </template>
                        </app-accordion>
                    </template>
                </draggable>
                <div class="mt-2">
                    <FloatingActionBtnFix :loader="preloader" :icon="'fa fa-check'" :message="message"
                        @dataSubmit="data_submit" @removeMessage="remove_msg" />
                </div>
            </div>
            <div v-else class="list_block m-5">
                <div class="office_block mt-4 p-4">
                    <div class="empty_content_block">
                        <div>
                            <i class="fa fa-box-open"></i>
                        </div>
                        <div class="mt-2">There is no data. Choose Organogram to get Decision List

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    import axios from 'axios'
    import { ref, toRefs, watchEffect, onMounted, watch, defineEmits } from 'vue'
    import ContentHeaderSection from "@/Shared/ContentHeaderSection"
    import FloatingActionBtnFix from "@/Shared/Buttons/FloatingActionBtnFix"

    import Multiselect from '@vueform/multiselect'
    import StatusToogleButton from '@/Shared/StatusToogleButton'
    import AppAccordion from "@/Shared/AppAccordion";
    import { VueDraggableNext as draggable } from 'vue-draggable-next'
    import { icon } from '@fortawesome/fontawesome-svg-core'
    import { isInteger } from 'lodash'
    export default {
        name: 'EmpOrganogramBlock',
        props: {
            designation_ids: Object,
            designation_data: Array,
            designationOption: Array,
            service_id: Number,
            geo_infos: Object,
            assign_on: [String, Number]
        },
        components: {
            ContentHeaderSection,
            FloatingActionBtnFix,
            draggable,
            Multiselect,
            StatusToogleButton,
            AppAccordion
        },
        setup(props, { emit }) {
            const backendPrefix = ref(process.env.MIX_ADMIN_PREFIX)
            const { service_id, designation_ids, designation_data, geo_infos, designationOption, assign_on } = toRefs(props)
            const preloader = ref(false)
            const sel_designations = ref(designation_ids)
            const message = ref('');
            const approvedatas = ref([])
            const decisions = ref([]);
            const designationOptions = ref(designationOption);

            const open = ref(assign_on.value || false);
            const value = ref([]);
            const dec_data = ref([]);
            const decison = ref([])
            const decisonInfos = ref([])
            const sel_designations_data = ref(designation_data)
            const deskassign = ref(designation_data)
            const layerData = ref([])
            const layers = ref([])
            const officeData = ref([])
            const proceed_type = ref([
                { id: 1, name: 'Desk' },
                { id: 2, name: 'Other Office Desk' },
                { id: 3, name: 'Other Office Multiple Desks' }
            ])

            const remove_msg = () => {
                message.value = ''
            }
            const onSelect = (event, index) => {
                let obj = {
                    id: event,
                    designation: [], // Always initialize as an empty array for Multiselect
                    layer: geo_infos.value.office_layer_id ?? null,
                    approve_status: null,
                    mode: null,
                    approve_data: [],
                    officeData: [],
                    optional: {},
                    proceed_type: 1 // Default to 1 (Desk)
                }
                sel_designations_data.value[index].alldecision.push(obj)
            }


            const approve_data_update = (data) => {
                if (!data.optional) data.optional = {}
                for (var i = 0; i < data.approve_data.length; i++) {
                    data.optional[data.approve_data[i]] = 0
                }

                //   //console.log('Get update data', data)
            }


            const onChangeAddData = (i) => {
                let d = designation_data.value[i].decision
                let obj = {
                    id: designation_data.value[i].decision[d.length - 1],
                    designation: [], // Always initialize as an empty array for Multiselect
                    layer: geo_infos.value.office_layer_id ?? null,
                    approve_status: null,
                    mode: null,
                    approve_data: [],
                    officeData: [],
                    optional: {},
                    proceed_type: 1 // Default to 1 (Desk)
                }
                sel_designations_data.value[i].alldecision.push(obj)
            }

            const onChangeRemoveData = (e, i) => {
                sel_designations_data.value[i].alldecision.forEach((v, ri) => {
                    if (v.id == e) {
                        sel_designations_data.value[i].alldecision.splice(ri, 1)
                        return true
                    }
                })
            }

            const getDecisionName = (decision, deci_id) => {
                let str = ''
                for (let index in decision) {
                    if (decision[index].value == deci_id) {
                        str = decision[index].label
                        break
                    }
                }
                return str
            }

            const multilelect = {
                mode: 'tags',
                placeholder: 'Select options',
                closeOnSelect: false,
                searchable: true,
                object: true,
                resolveOnLoad: false,
                delay: 0,
                minChars: 1,
                options: decisions
            }
            const loaddision = async () => {
                preloader.value = true
                let data = {
                    service_id: service_id
                }
                await axios.post(`/${backendPrefix.value}/serviceinfos/getallDesion`, data)
                    .then(function (response) {
                        response.data.data.forEach(element => {
                            if (element != null) {
                                let obj = {
                                    value: element.id, label: element.d_title, icon: element.icon
                                }
                                decison.value.push(obj);
                            }

                        });
                        preloader.value = false
                    });
            }
            const loaddisionInfo = async () => {
                preloader.value = true
                let data = {
                    service_id: service_id
                }
                await axios.post(`/${backendPrefix.value}/serviceinfos/getAllDesionInfo`, data)
                    .then(function (response) {
                        decisonInfos.value = response.data.data
                        preloader.value = false
                    });
            }
            const loadOfficeLayer = async () => {
                preloader.value = true
                let data = {
                    service_id: service_id.value,
                    officeLayer: geo_infos.value.office_layer_id
                }
                await axios.post(`/${backendPrefix.value}/serviceinfos/getOfficeLayer`, data)
                    .then(function (response) {
                        layerData.value = response.data.data

                        layers.value = response.data.data.map(layer => ({
                            value: layer.id,
                            label: layer.name,
                            layer: layer.layer
                        }));
                        preloader.value = false
                    });
            }
            const formatOfficeData = (offices) => {
                return offices.map(office => ({
                    value: office.id,
                    label: office.name
                }));
            }

            const handleChange = async (selectedValues, n_index, s_index) => {
                try {
                    if (!selectedValues || !layers.value) return;
                    const selectedLayerIds = layerData.value
                        .filter(layer => selectedValues.includes(layer.id))
                        .map(layer => (
                            layer.layer
                        ));
                    const org_id = selectedValues;
                    //selectedLayerIds qnique
                    const uniqueLayerIds = [...new Set(selectedLayerIds)];

                    const data = {
                        officeLayer: uniqueLayerIds,
                        org_id: org_id
                    };

                    const response = await axios.post(`/${backendPrefix.value}/serviceinfos/getDesk`, data);
                    if (response.data.status) {
                        const currentDecision = sel_designations_data.value[n_index].alldecision[s_index];
                        console.log('Data: ', currentDecision);

                        // Initialize designation as array if needed
                        if (!Array.isArray(currentDecision.designation)) {
                            currentDecision.designation = [];
                        }

                        // Format and set office data
                        const formattedData = formatOfficeData(response.data.data);
                        currentDecision.officeData = formattedData;
                        officeData.value = formattedData;
                        // Set layer information from the selected option
                        const layerIndex = layerData.value.findIndex(p => p.id == org_id[0]);
                        if (layerIndex !== -1) {
                            currentDecision.layer = layerData.value[layerIndex].layer;
                        }

                    } else {
                        officeData.value = [];
                    }
                } catch (error) {
                    console.error('Error loading office data:', error);
                } finally {
                    preloader.value = false;
                }


            }

            const loadOffice = async (event, org_id, parent_index = null, child_index = null) => {
                try {
                    preloader.value = true;

                    // Ensure org_id is always an array
                    if (!Array.isArray(org_id)) {
                        org_id = [org_id];
                    }

                    // Get all selected layers from the layerData
                    let officeLayer = org_id.map(id => {
                        const layer = layerData.value.find(l => l.id === id);
                        return layer ? layer.layer : null;
                    }).filter(Boolean);
                    if (event?.target?.options) {
                        // Handle regular select element
                        officeLayer = event.target.options[event.target.selectedIndex]?.getAttribute('data');
                    } else if (event?.data) {
                        // Handle Multiselect event
                        officeLayer = layerData.value.find(layer => layer.id === event.value)?.layer;
                    }

                    const data = {
                        officeLayer: officeLayer || null,
                        org_id: org_id
                    };

                    const response = await axios.post(`/${backendPrefix.value}/serviceinfos/getDesk`, data);

                    if (response.data.status) {
                        const currentDecision = sel_designations_data.value[parent_index].alldecision[child_index];

                        // Initialize designation as array if needed
                        if (!Array.isArray(currentDecision.designation)) {
                            currentDecision.designation = [];
                        }

                        // Format and set office data
                        const formattedData = formatOfficeData(response.data.data);
                        currentDecision.officeData = formattedData;
                        officeData.value = formattedData;

                        // Set layer information from the selected option
                        if (event?.data) {
                            currentDecision.layer = event.data;
                        } else {
                            const layerIndex = layerData.value.findIndex(p => p.id == org_id[0]);
                            if (layerIndex !== -1) {
                                currentDecision.layer = layerData.value[layerIndex].layer;
                            }
                        }
                    } else {
                        officeData.value = [];
                    }
                } catch (error) {
                    console.error('Error loading office data:', error);
                } finally {
                    preloader.value = false;
                }
            };

            const approvedata = async () => {
                preloader.value = true
                let data = {
                    service_id: service_id.value
                }
                await axios.post(`/${backendPrefix.value}/serviceinfos/approvedata`, data)
                    .then(function (response) {
                        approvedatas.value = response.data.data;
                        preloader.value = false
                    });
            }



            watch(props.geo_infos, (newValue, oldValue) => {
                loadOfficeLayer();
            })

            // Watch deskassign to ensure designation is always an array
            watch(deskassign, (newValue) => {
                if (newValue) {
                    newValue.forEach(designation => {
                        if (!Array.isArray(designation.decision)) {
                            designation.decision = [];
                        }
                        if (designation.alldecision) {
                            designation.alldecision.forEach(deci => {
                                if (!Array.isArray(deci.designation)) {
                                    deci.designation = []; // Always initialize as an empty array for Multiselect
                                }
                            })
                        }
                    })
                }
            }, { deep: true })

            const onClone = (index) => {
                if (index !== -1) {
                    let obj = deskassign.value[index];
                    deskassign.value.push(obj)
                }
            }
            const onRemove = (index) => {
                if (index !== -1) {
                    deskassign.value.splice(index, 1)
                }
            }
            onMounted(() => {
                loaddision();
                approvedata();
                loaddisionInfo();
                loadOfficeLayer();

            })

            const data_submit = () => {
                preloader.value = true;
                axios.post(`/${backendPrefix.value}/service-map`, {
                    designation_data: deskassign.value,
                    geos: geo_infos.value,
                    service_id: service_id.value
                }).then(async (response) => {
                    open.value = false;

                    message.value = response.data.message;
                    preloader.value = false;
                    //wait for 2 seconds
                    await new Promise(resolve => setTimeout(resolve, 2000));
                    emit('updateAssign', open.value);
                }).catch(error => {
                    preloader.value = false;
                });
            };
            return {
                preloader,
                service_id,
                designation_ids,
                message,
                remove_msg,
                backendPrefix,
                loaddision,
                designation_data,
                decisions,
                deskassign,
                multilelect,
                decison,
                data_submit,
                geo_infos,
                dec_data,
                approvedata,
                onSelect,
                approvedatas,
                sel_designations_data,
                getDecisionName,
                onChangeAddData,
                onChangeRemoveData,
                approve_data_update,
                decisonInfos,
                loaddisionInfo,
                loadOfficeLayer,
                layerData,
                loadOffice,
                officeData,
                onRemove,
                onClone,
                designationOptions,
                designationOption,
                open,
                proceed_type,
                handleChange,
                layers,
            }
        },

    }
</script>
<style lang="scss" scoped>
    .input_block {
        cursor: pointer;
    }

    .section_drag_cross {
        cursor: pointer;
        display: none;
    }

    .input_block:hover .section_checkbox {
        display: none;
        cursor: pointer;
    }

    .input_block:hover .section_drag_cross {
        display: block;
        cursor: pointer;
    }

    .designation_block {
        min-height: 24px;

        &>.input_block {
            width: 18px;
            height: 18px;
            display: flex;
            align-items: center;
            border: 1px solid #999;
            justify-content: center;
            border-radius: 5px;
        }

        &.active,
        &:hover {
            color: #006699;

            &>.input_block {
                border-color: #006699;

                &>i.remove {
                    display: none;
                }

                &>i.check {
                    display: block;
                    color: #006699
                }
            }
        }

    }
</style>
<style>

    .multiselect-wrapper,
    .multiselect {
        min-height: 26px !important;
    }

    span.action_button {
        width: 100%;
    }

    .listofdes {
        margin: 3px 0px;
        border: 1px solid #eee;
        border-radius: 8px;
    }

    .listofdes>.input_block i.rounded-full {
        border: 1px solid #999;
    }

    .listofdes>.input_block i {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        font-size: 10px;
    }

    .office_block {
        border-radius: 10px;
    }

    .empty_content_block>div i,
    .loader_content_block>div i {
        font-size: 34px;
        color: #ccc;
    }

    .empty_content_block>div,
    .loader_content_block>div {
        display: block;
        text-align: center;
    }

    .emp_organogram_block .list_block {
        border: 1px solid #ddd;
        border-radius: 5px;
    }

    li.mb-1 {
        border: 1px solid #cdcdcd;
        border-radius: 5px;
        padding: 8px;
    }

    .block.p-2.rounded-lg.shadow-lg.bg-white.w-full {
        border: 1px solid #c7c4c4;
    }
</style>
